import type { ChatMessage } from '@chewy/chat-library-common';
import { FloatingCircles, FloatingCirclesProps } from '@chewy/chat-library-components';
import styles from './FloatingCirclesMessage.module.scss';

export interface FloatingCirclesMessagePayload {
  animationProps?: Partial<FloatingCirclesProps>;
}

export function FloatingCirclesMessage({
  message
}: {
  message?: ChatMessage<FloatingCirclesMessagePayload>
}) {
  const { animationProps } = message?.payload ?? {};

  return (
    <div className={styles.container}>
      <FloatingCircles {...animationProps} />
    </div>
  );
}

export default FloatingCirclesMessage;
